import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Disclaimer from '@websky/core/src/Disclaimer/Disclaimer';
import { useTheme } from '@websky/core/src/theme';
import { Details } from '@websky/core/src/Icons';
var SearchFormNotices = function () {
    var css = useTheme('Exchange').SearchFlights;
    var t = useTranslation('Exchange').t;
    return (React.createElement(React.Fragment, null,
        React.createElement(Disclaimer, { className: css.notice_item, icon: Details }, t('Surcharge is for all passengers and includes taxes and fees'))));
};
export default SearchFormNotices;
